module.exports = __webpack_public_path__ + "static/media/linkedin.2ed1007b.svg";